/* src/app/modules_v2/booking/locations/components/sections/location-availability-section/location-availability-section.component.css */
.availability-section {
  padding: 20px;
}
.section-header h6.fw-bold {
  color: #333;
  font-size: 18px;
  margin-bottom: 5px;
}
.section-header .text-muted {
  font-size: 13px;
  color: #666;
}
.staff-panel {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  height: calc(100vh - 250px);
  min-height: 500px;
  display: flex;
  flex-direction: column;
}
.staff-search {
  flex-shrink: 0;
}
.staff-list {
  flex: 1;
  overflow-y: auto;
  margin: 0 -15px;
  padding: 0 15px;
}
.staff-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 8px;
}
.staff-item:hover {
  background: #f5f5f5;
}
.staff-item.active {
  background: #fff8e1;
  border-left: 3px solid #e3fd64;
}
.staff-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e3fd64;
  color: #1a1d23;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}
.staff-item.active .staff-avatar {
  background: #e59700;
}
.staff-info {
  flex: 1;
  min-width: 0;
}
.staff-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.staff-empty {
  text-align: center;
  padding: 40px 20px;
}
.staff-empty mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #ccc;
  margin-bottom: 10px;
}
.staff-empty p {
  margin: 0;
  font-size: 13px;
  color: #999;
}
.no-selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background: #fafafa;
  border: 2px dashed #ccc;
  border-radius: 8px;
  min-height: 500px;
}
.no-selection mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #999;
  margin-bottom: 20px;
}
.no-selection h5 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.no-selection p {
  font-size: 14px;
}
.availability-config {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  min-height: 500px;
}
.config-header {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 15px;
}
.config-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e3fd64;
  color: #1a1d23;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  margin-right: 15px;
}
.config-header h5 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.availability-tabs {
  margin-top: 20px;
}
.tab-content {
  padding: 20px 0;
}
.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}
.tab-header h6 {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 0 0 5px 0;
}
.tab-header .text-muted {
  font-size: 13px;
  color: #666;
  margin: 0;
}
.table-container {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table thead {
  background: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
}
.data-table th {
  padding: 12px 15px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.data-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}
.data-table tbody tr:hover {
  background-color: #fafafa;
}
.data-table tbody tr:last-child {
  border-bottom: none;
}
.data-table tbody tr.inactive-row {
  opacity: 0.6;
}
.data-table td {
  padding: 12px 15px;
  font-size: 13px;
  color: #333;
  vertical-align: middle;
}
.text-center {
  text-align: center;
}
.badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}
.badge.badge-closed {
  background: #ffebee;
  color: #c62828;
}
.badge.badge-special {
  background: #fff8e1;
  color: #e3fd64;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background: #fafafa;
  text-align: center;
}
.empty-state mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #999;
  margin-bottom: 20px;
}
.empty-state h5 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.empty-state p {
  font-size: 13px;
  margin-bottom: 20px;
  max-width: 400px;
}
.w-100 {
  width: 100%;
}
.mb-3 {
  margin-bottom: 15px;
}
.d-flex {
  display: flex;
}
.align-items-center {
  align-items: center;
}
@media (max-width: 992px) {
  .staff-panel {
    height: auto;
    min-height: 300px;
    margin-bottom: 20px;
  }
  .availability-config {
    min-height: auto;
  }
}
@media (max-width: 768px) {
  .availability-section {
    padding: 15px;
  }
  .table-container {
    overflow-x: auto;
  }
  .data-table {
    min-width: 600px;
  }
  .tab-header {
    flex-direction: column;
    gap: 15px;
  }
  .tab-header app-button {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .data-table {
    min-width: 480px;
  }
}
.weekday-tabs {
  margin-top: 10px;
}
.weekday-tabs .mat-tab-label,
.weekday-tabs .mdc-tab {
  min-width: 90px;
  padding: 0 16px;
  height: 40px;
  font-size: 13px;
  font-weight: 500;
  opacity: 0.75;
}
.weekday-tabs .mat-tab-label-active,
.weekday-tabs .mdc-tab--active {
  opacity: 1;
}
.weekday-tab-content {
  padding: 15px 4px 4px;
}
.empty-state-weekday {
  padding: 28px 16px;
}
.empty-state-weekday mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
}
.empty-state-weekday h6 {
  margin-bottom: 4px;
  color: #333;
}
@media (max-width: 576px) {
  .weekday-tabs .mat-tab-label,
  .weekday-tabs .mdc-tab {
    min-width: 70px;
    padding: 0 10px;
    font-size: 12px;
  }
}
/*# sourceMappingURL=location-availability-section.component.css.map */
